module.exports = __webpack_public_path__ + "img/header_dsk.046fec9.webp";